import { render, staticRenderFns } from "./NoteListView.vue?vue&type=template&id=0a13babc&scoped=true"
import script from "./NoteListView.vue?vue&type=script&lang=js"
export * from "./NoteListView.vue?vue&type=script&lang=js"
import style0 from "./NoteListView.vue?vue&type=style&index=0&id=0a13babc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a13babc",
  null
  
)

export default component.exports